import React, { useState } from 'react';
import Editor from '@monaco-editor/react';

export const MinifierView: React.FC = () => {
  const [code, setCode] = useState<string>('');
  const [error, setError] = useState<string | null>(null);

  const minifyJSON = () => {
    try {
      if (!code.trim()) return;
      const parsed = JSON.parse(code) as unknown;
      setCode(JSON.stringify(parsed));
      setError(null);
    } catch (err: unknown) {
      if (err instanceof Error) {
        setError(err.message);
      } else {
        setError(String(err));
      }
    }
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0, padding: '1rem' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
        <div>
          <h2 style={{ margin: 0 }}>Minifier</h2>
          <p style={{ margin: '0.25rem 0 0', color: 'var(--color-text-secondary)' }}>Strip whitespace and comments to compress JSON.</p>
        </div>
        <button onClick={minifyJSON} style={{ padding: '0.5rem 1rem', background: 'var(--color-accent)', color: 'var(--color-on-accent)', border: 'none', borderRadius: '4px', cursor: 'pointer', fontWeight: 600 }}>
          Minify JSON
        </button>
      </div>
      {error && <div style={{ color: 'red', marginBottom: '1rem', padding: '0.5rem', background: '#ffebee', borderRadius: '4px' }}>{error}</div>}
      <div style={{ flex: 1, minHeight: 0, position: 'relative', border: '1px solid var(--color-border)', borderRadius: '8px', overflow: 'hidden' }}>
          <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0 }}>
        <Editor
          height="100%"
          defaultLanguage="json"
          value={code}
          onChange={(value) => { setCode(value ?? ''); }}
          theme="vs-dark"
          options={{
            minimap: { enabled: false },
            wordWrap: 'on',
            scrollbar: { vertical: 'auto', horizontal: 'auto' },
            padding: { top: 16 }
          }}
        />
      </div>
        </div>
    </div>
  );
};
